import api from "../store/services/api";

export const getNeighborhoodGroups = (params) =>
  api.get("/delivery-center/delivery-groups/", { params });

export const createNeighborhoodGroup = (neighborhoodGroup) =>
  api.post("/delivery-center/delivery-groups/", neighborhoodGroup, {
    headers: { "Content-Type": "application/json" },
  });

export const editNeighborhoodGroup = (neighborhoodGroup, neighborhoodGroupId) =>
  api.put(
    `/delivery-center/delivery-groups/?gid=${neighborhoodGroupId}`,
    neighborhoodGroup,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const deleteNeighborhoodGroup = (neighborhoodGroup) =>
  api.delete(`/delivery-center/delivery-groups/?gid=${neighborhoodGroup}`);

const WorkShiftService = {
  getNeighborhoodGroups,
  createNeighborhoodGroup,
  editNeighborhoodGroup,
  deleteNeighborhoodGroup,
};

export default WorkShiftService;
